import React, { ReactNode } from 'react'
import styled from 'styled-components'

type BulkCreateApplicationPageInfoProps = {
  className?: string
  title: string | ''
  instructions: ReactNode
}

const BulkCreateApplicationPageInfo = ({
  className,
  title,
  instructions
}: BulkCreateApplicationPageInfoProps) => {
  return (
    <div className={className}>
      <span className="info-page-title">
        <span>{title}</span>
      </span>
      <div className="info">
        <div>{instructions}</div>
      </div>
    </div>
  )
}

export default styled(BulkCreateApplicationPageInfo)`
  font-size: 14px;
  margin-bottom: 1rem;
  .info-page-title {
    color: ${(props) => props.theme.clientColors.text};
    font-size: 30px;
  }

  .info-page-title > span {
    font-weight: bolder;
  }

  .info {
    display: grid;
    margin-top: 12px;
  }

  .info > div {
    grid-template-rows: 20px;
  }

  .info > div > span:first-child {
    font-weight: 600;
  }
`
